module.exports = __webpack_public_path__ + "assets/get-fail-783a76aa.png";